import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocationHash, useLocationSearch, useNavigate } from '@rocketlane/rocket-router';
import { stringify } from 'query-string';
import { useLayoutEffect } from 'react';
import { ProjectId, TaskIdV2 } from 'api/models';
import { createTransformer } from 'components/organisms/task-drawer/transformer';
import { useUser } from 'hooks/use-user';
export const TaskPaneHashRewrite = ({ children })=>{
    const replace = useNavigate();
    const hash = useLocationHash();
    const search = useLocationSearch();
    const { user } = useUser();
    useLayoutEffect(()=>{
        var _ref, _ref1;
        var _match;
        const groups = (_match = (hash !== null && hash !== void 0 ? hash : '').match(/.*task(?<project_id>\d+)!(?<task_id>\d+).*/)) === null || _match === void 0 ? void 0 : _match.groups;
        const project_id = parseInt((_ref = groups === null || groups === void 0 ? void 0 : groups.project_id) !== null && _ref !== void 0 ? _ref : '', 10);
        const task_id = parseInt((_ref1 = groups === null || groups === void 0 ? void 0 : groups.task_id) !== null && _ref1 !== void 0 ? _ref1 : '', 10);
        const open_approvals_tab = search.includes('tab=approvals');
        if (!Number.isNaN(project_id) && !Number.isNaN(task_id)) {
            replace({
                search,
                hash: `${hash.replace(`task${project_id}!${task_id}`, stringify(createTransformer({
                    userType: user === null || user === void 0 ? void 0 : user.userType
                }).to([
                    'show',
                    ProjectId(project_id),
                    TaskIdV2(task_id)
                ])))}${open_approvals_tab ? '&task_drawer_tab=approvals' : ''}`
            }, {
                replace: true
            });
        }
    }, [
        hash,
        search,
        replace,
        user === null || user === void 0 ? void 0 : user.userType
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
